import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingLeft: 18,
    margin: 0,
  },
  listItem: {
    listStyle: 'disc',
    fontSize: 16,
  },
  span: {
    fontWeight: 600,
  },
  link: {
    fontWeight: 500,
  },
  linkPortal: {
    fontWeight: 600,
    fontFamily: 'Arial',
  },
  title: {
    fontSize: 24,
  },
  description: {
    fontSize: 16,
  },
  tableCell: { border: 0, padding: '4px 8px' },
}))

export default styles
